import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';

import CurrentUserContext from 'contexts/CurrentUserContext';
import { IS_INSIGHTS_ENABLED } from 'hooks/useInsightsChatBudget';
import Icon from 'kingpin/atoms/Icon';
import Tooltip from 'components/Tooltip';

import { buildInsightsAgent } from '../../../../../appRoutes';
import NavIconItem from '../../../Common/NavIconItem';

const AgentManagement = () => {
  const { isFleetOpsStaff } = useContext(CurrentUserContext);

  // The system knowledge base shapes every customer's agent — staff only, not
  // account admins. The screen and the server both re-check this. Hidden, and
  // its route unregistered, while Insights is off (see IS_INSIGHTS_ENABLED).
  if (!IS_INSIGHTS_ENABLED || !isFleetOpsStaff) {
    return null;
  }

  return (
    <Tooltip content={'AI Agent'}>
      {/* V3 Standard is FleetOps's non-portal UI, so no portal is threaded
          through here (matches sibling Settings.tsx) */}
      <NavLink to={buildInsightsAgent(undefined)}>
        <NavIconItem>
          <Icon
            icon="note-stack-add"
            color="var(--color-icon-primary)"
            width={19}
            height={19}
          />
        </NavIconItem>
      </NavLink>
    </Tooltip>
  );
};

export default AgentManagement;
